import { render, staticRenderFns } from "./EModalFaltaAlunoFranquia.vue?vue&type=template&id=05c2e07e&scoped=true"
import script from "./EModalFaltaAlunoFranquia.vue?vue&type=script&lang=js"
export * from "./EModalFaltaAlunoFranquia.vue?vue&type=script&lang=js"
import style0 from "./EModalFaltaAlunoFranquia.vue?vue&type=style&index=0&id=05c2e07e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c2e07e",
  null
  
)

export default component.exports